export const TaxDialogStyles = {
  CommonTaxDialog: {
    modalHeader: {
      paddingBottom: '20px !important',
    },
    modalContent: {
      paddingBottom: '20px',
    },
  },
};
